<div class="subnav d-print-none">
  <div class="row">
    <div class="col-12" id="subnav">
      <ul>
        @for (item of items; track item; let i = $index) {
          <li>
            <a class="nav-link nav-link-{{item.key}}" [ngClass]="{'nav-selected': i===0}" (click)="navigateTo(item.key)" href="javascript:void(0)">{{item.title}}</a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
